export default function getLocale(sessionLocale?: string): string {
  return sessionLocale || window.navigator.language.slice(0, 2) || 'en';
}
